const state = {
    hrpermissions:{},
    hrusergroups:[],
};

const getters = {
    getHrPermissions: state => state.hrpermissions,
    getHrUsergroups: state => state.hrusergroups,
};

const actions = {
    setHrPermissions: (store, payload) => store.commit('HRPERMISSIONS_SET', payload),
    setHrUsergroups: (store, payload) => store.commit('HRUSERGROUPS_SET',payload),
};

const mutations = {
    HRPERMISSIONS_SET: (state, payload) => state.hrpermissions = payload,
    HRUSERGROUPS_SET: (state, payload) => state.hrusergroups = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
